import {
  Card,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardBody,
  CardTitle,
} from "reactstrap";
import React, { useState } from "react";
import classnames from "classnames";
import {
  serveRequest,
  // setStartTimeRequest,
  setEndTimeRequest,
} from "../../../api/controller/ManageDockController";
import moment from "moment";
import { Loader } from "../../../custom/components/Loader";
import { STORAGE_PUBLIC_BASE } from "../../../custom/helpers/storagePublicBase";

const DockingQueue = ({
  zones,
  selectedZone,
  goToManageDock,
  dockingRequests,
}) => {
  console.log(dockingRequests);
  const [currentScreen, setCurrentScreen] = useState("initial");
  const [error, setError] = useState({});
  const [status] = useState([
    "PENDING",
    "DOCKED",
    "PAYMENT PENDING",
  ]);
  const [selectedStatus, setSelectedStatus] = useState("PENDING");
  const [selectedDockingRequest, setSelectedDockingRequest] = useState();
  const [selectedDockingSlotIds, setSelectedDockingSlotIds] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedVesselId, setSelectedVesselId] = useState(null);

  const goToAssignSlot = ({ request }) => {
    setError({});
    setCurrentScreen("assignSlot");
    setSelectedDockingRequest(request);
    setStartTime(moment().format("YYYY-MM-DD HH:mm"));
  };

  const goToUpdateTime = ({ request }) => {
    setError({});
    setStartTime(
      request.start_time === null
        ? moment().format("YYYY-MM-DD HH:mm")
        : request.start_time
    );
    setEndTime(
      request.end_time === null
        ? moment().format("YYYY-MM-DD HH:mm")
        : request.end_time
    );
    setCurrentScreen("updateTime");
    setSelectedDockingRequest(request);
  };

  const addRemoveSlot = (slotId) => {
    let newSelectedSlots;
    if (selectedDockingSlotIds.includes(slotId)) {
      newSelectedSlots = selectedDockingSlotIds.filter((id) => id !== slotId);
    } else {
      newSelectedSlots = [...selectedDockingSlotIds, slotId];
    }
    setSelectedDockingSlotIds(newSelectedSlots);
  };

  const handleAssignSlot = async () => {
    setLoading(true);
    setError({});
    const response = await serveRequest({
      DockingRequest: selectedDockingRequest.id,
      StartTime: moment(startTime).format("YYYY-MM-DD HH:mm"),
      Slots: selectedDockingSlotIds,
    });
    if (response.Status === "error") {
      if (
        response.payload?.errors &&
        Object.keys(response.payload?.errors).length > 0
      ) {
        setError({
          Message:
            response.payload.errors[Object.keys(response.payload.errors)[0]][0],
        });
      } else {
        setError({ Message: response.Message });
      }
    } else {
      setCurrentScreen("initial");
    }
    setLoading(false);
  };

  const handleUpdateEndTime = async () => {
    setLoading(true);
    setError({});
    const response = await setEndTimeRequest({
      DockingRequest: selectedDockingRequest.id,
      EndTime: moment(endTime).format("YYYY-MM-DD HH:mm"),
    });
    if (response.Status === "error") {
      setError({ Message: response.Message });
    } else {
      setCurrentScreen("initial");
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Loader loading={loading} transparent />

      {/* Image Modal */}
      {showImageModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.9)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <button
            className="btn btn-light mb-3"
            onClick={() => setShowImageModal(false)}
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              zIndex: 10000,
            }}
          >
            <span className="mdi mdi-close align-middle fs-4"></span>
          </button>
          <img
            src={STORAGE_PUBLIC_BASE + selectedVesselId?.vessel_image}
            alt="Vessel"
            style={{
              maxWidth: "100%",
              maxHeight: "calc(100vh - 80px)",
              objectFit: "contain",
              marginTop: "60px",
            }}
          />
        </div>
      )}

      {currentScreen === "initial" && (
        <React.Fragment>
          <button
            className="btn btn-primary fs-6 py-1"
            onClick={() => goToManageDock()}
          >
            <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span>
            <span className="">Back</span>
          </button>
          <Card className="px-3 pt-1 mt-4 mb-3 pb-3">
            <h4 className="pt-3 font-weight-semibold">
              Manage -{" "}
              <span className="text-primary">{selectedZone?.label}</span>
            </h4>

            <div className="mt-3">
              <Nav pills className="navtab-bg nav-justified">
                {status.map((item, key) => (
                  <NavItem key={key} className="border m-1">
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: selectedStatus === item,
                      })}
                      onClick={() =>
                        selectedStatus !== item
                          ? setSelectedStatus(item)
                          : false
                      }
                    >
                      {item}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </div>
          </Card>
          <Card className="p-3">
            <TabContent activeTab={selectedStatus} className="p-1 text-muted">
              {status.map((item, key) => (
                <TabPane key={key} tabId={item}>
                  {dockingRequests &&
                  dockingRequests.filter((r) => r.status === selectedStatus)
                    .length > 0 ? (
                    dockingRequests
                      .filter((r) => r.status === selectedStatus)
                      .sort((a, b) => a - b)
                      .map((item, key) => {
                        return (
                          <Card className="border mb-2" key={key}>
                            <Row className="" style={{ paddingRight: "12px" }}>
                              <Col
                                className="col-8 my-2"
                                style={{ paddingLeft: "25px" }}
                              >
                                <Col>
                                  <span className=" font-weight-semibold text-muted fs-6">
                                    Vessel:{" "}
                                  </span>
                                  &nbsp;&nbsp;
                                  <span className="font-weight-semibold fs-6 text-primary">
                                    {item.vessel?.name} (
                                    {item.vessel?.registration_number})
                                  </span>
                                  &nbsp;&nbsp;
                                  <button
                                    className="btn btn-sm btn-light"
                                    onClick={() => {
                                      setSelectedVesselId(item.vessel);
                                      setShowImageModal(true);
                                    }}
                                  >
                                    <span className="mdi mdi-image-area fs-5"></span>
                                  </button>
                                </Col>
                                <Col>
                                  <span className=" font-weight-semibold text-muted fs-6">
                                    Rep:{" "}
                                  </span>
                                  &nbsp;&nbsp;
                                  <span className="font-weight-semibold fs-6 text-warning">
                                    {item.vessel?.representative_name} (
                                    {item.vessel?.representative_contact_number}
                                    )
                                  </span>
                                </Col>
                                {item.status !== "PENDING" && (
                                  <Col>
                                    <span className=" font-weight-semibold text-muted fs-6">
                                      Slot:{" "}
                                    </span>
                                    &nbsp;&nbsp;
                                    <span className="font-weight-semibold fs-6 text-primary">
                                      {item.slots
                                        ?.map((s) => s.name)
                                        .join(", ")}{" "}
                                    </span>
                                  </Col>
                                )}
                                {item.status !== "PENDING" && (
                                  <Col>
                                    <span className=" font-weight-semibold text-muted fs-6">
                                      Start Time:{" "}
                                    </span>
                                    &nbsp;&nbsp;
                                    <span className="font-weight-semibold fs-6 text-success">
                                      {moment(item.start_time).format("HH:mm")}
                                    </span>
                                  </Col>
                                )}
                              </Col>
                              {item.status === "PENDING" && (
                                <Col
                                  onClick={() =>
                                    goToAssignSlot({ request: item })
                                  }
                                  className="col-4 bg-primary text-light align-middle"
                                  style={{
                                    cursor: "pointer",
                                    borderRadius: "0px 5px 5px 0px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span className="me-2">Assign</span>
                                  <span className="mdi mdi-chevron-right align-middle fs-3"></span>
                                </Col>
                              )}
                              {item.status === "DOCKED" && (
                                <React.Fragment>
                                  <Col
                                    onClick={() =>
                                      goToUpdateTime({ request: item })
                                    }
                                    className="col-4 bg-primary text-light align-middle"
                                    style={{
                                      cursor: "pointer",
                                      borderRadius: "0px 5px 5px 0px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span className="me-2">Stop</span>
                                    <span className="mdi mdi-chevron-right align-middle fs-3"></span>
                                  </Col>
                                </React.Fragment>
                              )}
                            </Row>
                          </Card>
                        );
                      })
                  ) : (
                    <span className="text-center align-middle">
                      There are no vessels in this status.
                    </span>
                  )}
                </TabPane>
              ))}
            </TabContent>
          </Card>
        </React.Fragment>
      )}

      {currentScreen === "assignSlot" && (
        <React.Fragment>
          <button
            className="btn btn-primary fs-6 py-1"
            onClick={() => setCurrentScreen("initial")}
          >
            <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span>
            <span className="">Back</span>
          </button>

          <Card className="px-3 py-1 mt-4 mb-3">
            <Row>
              <Col className="col-12">
                <h4 className="pt-3 font-weight-semibold ">Assign Slot</h4>
              </Col>
              <Col classname="col-md-4 col-lg-4 col-xl-3">
                <label className="col-md-2 col-form-label">Start Time</label>
                <div className="col-md-10">
                  <input
                    className="form-control"
                    type="datetime-local"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                  />
                </div>
              </Col>
              <Col className="col-md-4 col-lg-4 col-xl-3">
                <label className="col-md-2 col-form-label">Zone</label>
                <div>
                  <input
                    disabled
                    className="form-control"
                    type="text"
                    value={selectedDockingRequest.zone.name}
                  />
                </div>
              </Col>
              <Col className="col-12">
                <Row>
                  <Col className="col-12">
                    <label className="col-md-2 col-form-label">Slots</label>
                  </Col>
                  <Col className="col-12">
                    <Row>
                      {zones
                        .filter((z) => z.id === selectedZone.value)
                        .map((item_zone, key_zone) =>
                          selectedDockingRequest.type === "Berthing"
                            ? item_zone.berthing_slots.map(
                                (item_slot, key_slot) => (
                                  <Col
                                    key={key_zone + "-" + key_slot}
                                    className="col-md-3 col-lg-3 col-xl-2"
                                  >
                                    <Card
                                      outline
                                      color={
                                        selectedDockingSlotIds.includes(
                                          item_slot.id
                                        )
                                          ? "warning"
                                          : "success"
                                      }
                                      className="p-2 border"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        addRemoveSlot(item_slot.id)
                                      }
                                    >
                                      <div>{item_slot.name}</div>
                                    </Card>
                                  </Col>
                                )
                              )
                            : selectedDockingRequest.type === "Mooring"
                            ? item_zone.mooring_slots.map(
                                (item_slot, key_slot) => (
                                  <Col
                                    key={key_slot}
                                    className="col-md-3 col-lg-3 col-xl-2"
                                  >
                                    <Card
                                      outline
                                      color={
                                        selectedDockingSlotIds.includes(
                                          item_slot.id
                                        )
                                          ? "warning"
                                          : "success"
                                      }
                                      className="p-2 border"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        addRemoveSlot(item_slot.id)
                                      }
                                    >
                                      <div>{item_slot.name}</div>
                                    </Card>
                                  </Col>
                                )
                              )
                            : null
                        )}
                    </Row>
                  </Col>
                </Row>
              </Col>

              {/* <Col className="col-md-4 col-lg-4 col-xl-3">
                <label className="col-md-2 col-form-label">Slot</label>
                <div>
                  <select
                    className="form-control"
                    placeholder="Select slot"
                    value={selectedDockingSlotId}
                    onChange={(e) => setSelectedDockingSlotId(e.target.value)}
                  >
                    {zones
                      .filter((z) => z.id === selectedZone.value)
                      .map((item_zone, key_zone) =>
                        selectedDockingRequest.type === "Berthing"
                          ? item_zone.berthing_slots.map(
                              (item_slot, key_slot) => (
                                <option
                                  key={key_zone + "-" + key_slot}
                                  value={item_slot.id}
                                >
                                  {item_slot.name}
                                </option>
                              )
                            )
                          : selectedDockingRequest.type === "Mooring"
                          ? item_zone.mooring_slots.map(
                              (item_slot, key_slot) => (
                                <option
                                  key={key_zone + "-" + key_slot}
                                  value={item_slot.id}
                                >
                                  {item_slot.name}
                                </option>
                              )
                            )
                          : null
                      )}
                  </select>
                </div>
              </Col> */}
            </Row>

            <Col className="col-md-4 col-lg-4 col-xl-3">
              <div className="mt-2 pt-2 mb-3">
                <button
                  className="btn btn-primary fs-6 w-100"
                  onClick={() => handleAssignSlot()}
                >
                  <span className="mdi mdi-check align-middle fs-3 me-2"></span>
                  <span className="">Submit</span>
                </button>
              </div>
            </Col>
            {error.Message && error.Message.length > 0 ? (
              <Col>
                <Card color="danger" className="text-white-50">
                  <CardBody className="p-3">
                    <CardTitle className="mb-2 text-white">
                      <i className="mdi mdi-block-helper me-3" />
                      Error
                    </CardTitle>
                    <span className="text-white">{error.Message}</span>
                  </CardBody>
                </Card>
              </Col>
            ) : null}
          </Card>
        </React.Fragment>
      )}

      {currentScreen === "updateTime" && (
        <React.Fragment>
          <button
            className="btn btn-primary fs-6 py-1"
            onClick={() => setCurrentScreen("initial")}
          >
            <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span>
            <span className="">Back</span>
          </button>

          <Card className="px-3 py-1 mt-4 mb-3">
            <Col>
              <h4 className="pt-3 font-weight-semibold ">Update Time</h4>
            </Col>
            <Col sm={6} className="mb-3">
              {selectedStatus === "DOCKED" ? (
                <div>
                  <label className="col-md-2 col-form-label">Finish Time</label>
                  <Row>
                    <Col>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="datetime-local"
                          value={endTime}
                          onChange={(e) => setEndTime(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col>
                      <button
                        className="btn btn-primary w-100"
                        onClick={() => handleUpdateEndTime()}
                      >
                        {/* <span className="mdi mdi-check align-middle fs-5 me-2"></span> */}
                        <span className="">Finish</span>
                      </button>
                    </Col>
                  </Row>
                </div>
              ) : null}
            </Col>
            {error.Message && error.Message.length > 0 ? (
              <Col>
                <Card color="danger" className="text-white-50">
                  <CardBody className="p-3">
                    <CardTitle className="mb-2 text-white">
                      <i className="mdi mdi-block-helper me-3" />
                      Error
                    </CardTitle>
                    <span className="text-white">{error.Message}</span>
                  </CardBody>
                </Card>
              </Col>
            ) : null}
          </Card>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default DockingQueue;
